import {Box, Button, Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import DefaultDialog, {DefaultDialogSize} from "./ClosableDialog";
import React from "react";

export interface ConfirmFormProps {
    title: string;
    bodyText?: string;
    titleConfirm?: string;
    isOpen: boolean;
    onConfirm: () => Promise<void>;
    onClose: () => void;
    children?: React.ReactNode | React.ReactNode[];
}

export default function ConfirmDialog({
    title,
    bodyText,
    isOpen,
    titleConfirm,
    onConfirm,
    onClose,
    children,
}: ConfirmFormProps) {
    const {t} = useTranslation();

    return (
        <DefaultDialog
            size={DefaultDialogSize.LARGE}
            open={isOpen}
            titleKey={t(title)}
            onClose={onClose}
            actions={[
                <Box key="confirm">
                    <Button color="primary" variant="contained" type="submit" onClick={onConfirm}>
                        {titleConfirm || t("generic_confirm")}
                    </Button>
                </Box>,
            ]}
        >
            <Grid container sx={{marginTop: "12px"}}>
                <Grid item>
                    <Typography variant={"body1"}>{bodyText}</Typography>
                </Grid>
            </Grid>
            {children}
        </DefaultDialog>
    );
}
